"use client";

import Link from "next/link";
import { getClass as getButtonClass } from "@/lib/components/Button";
import React from "react";
import Dialog from "@/lib/components/Dialog";
import { OrganisationWithManagers } from "@/lib/prisma";
import { deleteOrganisation } from "./organisations/actions";

export default function Organisation(props: {
  organisation: OrganisationWithManagers;
}): React.ReactNode {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 ring ring-gray rounded-lg p-2 w-full">
        <h2 className="text-lg flex-1">{props.organisation.name}</h2>
        <div className="flex flex-col flex-1">
          <strong>Managers:</strong>
          {props.organisation.managers.map((manager) => (
            <p key={manager.userId}>{manager.user.email}</p>
          ))}
        </div>
        <div className="flex flex-row gap-2 self-end sm:self-center">
          <Link
            href={`/organisations/${props.organisation.id}`}
            className={getButtonClass({ size: "sm", variant: "light" })}
          >
            Edit
          </Link>
          <button
            className={getButtonClass({ size: "sm", variant: "danger" })}
            onClick={() => setDialogOpen(true)}
          >
            Delete
          </button>
        </div>
      </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <p>
          Are you sure you want to delete{" "}
          <strong>{props.organisation.name}</strong>?
        </p>
        <div className="flex flex-row gap-2 justify-end">
          <button
            onClick={() => setDialogOpen(false)}
            className={getButtonClass({ size: "sm", variant: "light" })}
          >
            Cancel
          </button>
          <button
            onClick={() => deleteOrganisation(props.organisation.id)}
            className={getButtonClass({ size: "sm", variant: "danger" })}
          >
            Delete
          </button>
        </div>
      </Dialog>
    </>
  );
}
